import { SelectChangeEvent } from "@mui/material";
import { API } from "../../../../globals/globals";
import { useFailoverMutation, useGetConfigurationQuery, useGetStatusQuery, useResetActiveMutation } from "../../../../store/api/admin/adminApiSlice"
import { setOpenToast } from "../../../../store/helpers/helperReducers";
import { useStoreDispatch } from "../../../../store/hooks";
import { logout } from "../../../../store/api/auth/reducer";
import { useState } from "react";

export const useTriConnection = () => {

    const { data, isLoading, error } = useGetConfigurationQuery(undefined, { pollingInterval: API?.ENDPOINTS?.CONFIGURATION?.pollingInterval || 10000 });
    // const {data:statusData,isLoading:statusLoading,error:statusError} = useGetStatusQuery()
    const { data: statusData, isLoading: statusIsLoading, error: statusError, refetch: refetchStatus } = useGetStatusQuery(undefined, { pollingInterval: API?.ENDPOINTS?.STATUS?.pollingInterval || 10000 });
    const [resetActive] = useResetActiveMutation();
    const [failover] = useFailoverMutation();
    const dispatch = useStoreDispatch();
    const [activeSetting, setActiveSetting] = useState<string>('');
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogType, setDialogType] = useState<'switch_to_standby_server' | 'break_redundancy' | null>(null);

    const handleChange = (event: SelectChangeEvent<string>) => {
        const value = event.target.value as 'switch_to_standby_server' | 'break_redundancy';
        setActiveSetting(value);
        setDialogType(value);
        setOpenDialog(true);
    };

    const handleDialogClose = () => {
        setOpenDialog(false);
        setDialogType(null);
        setActiveSetting('')
    };

    const handleConfirm = async () => {
        try {
            let result;
            let successMessage;

            switch (dialogType) {
                case 'switch_to_standby_server':
                    result = await failover({});
                    successMessage = 'Successfully switched to standby server';
                    break;
                case 'break_redundancy':
                    result = await resetActive({});
                    successMessage = 'Successfully broke redundancy';
                    break;
                default:
                    return;
            }

            // Check for error response
            if ('error' in result) {
                dispatch(setOpenToast({
                    openToast: true,
                    message: 'error' in result.error && 'data' in result.error ? String(result.error.data) : 'An error occurred',
                    toastType: 'error'
                }));
                return;
            }

            // Check for successful response
            if ('data' in result) {
                if (result.data.status === 200) {
                    dispatch(setOpenToast({
                        openToast: true,
                        message: `${successMessage}. Logging out...`,
                        toastType: 'success'
                    }));

                    // Ensure logout happens for both cases
                    setTimeout(() => {
                        logoutHandler();
                    }, 5000);

                    // await refetchStatus();
                } else {
                    dispatch(setOpenToast({
                        openToast: true,
                        message: 'Operation failed',
                        toastType: 'error'
                    }));
                }
            }

        } catch (error) {
            dispatch(setOpenToast({
                openToast: true,
                message: (error as any)?.data ?? 'An unexpected error occurred',
                toastType: 'error'
            }));
        } finally {
            setActiveSetting('');
            handleDialogClose();
        }
    };

    const logoutHandler = () => {
        dispatch(logout());
        window.location.reload();
    };

    // useEffect(() => {
    //     const partialRefInterval = setInterval(() => {
    //         fetchConfiguration()
    //     }, 10000);
    //     return () => clearInterval(partialRefInterval);
    // }, []);


    return { handleChange, handleDialogClose, activeSetting, handleConfirm, dialogType, openDialog, data, isLoading, error, statusData, statusIsLoading, statusError, refetchStatus};

}